Vue.asyncComponent('cms-history', {
    computed: {
        activeBundle() {
            return this.bundle ? this.bundle : this.$route.params.bundle;
        },
    },
    props: {
        bundle: {
            type: String,
            required: false
        }
    },
    data () {
        return {
            showError: false,
            data: null,
            page: 1,
            limit: 25,
            modalData: null,
        };
    },
    methods: {
        /**
         * Fetch data
         */
        async fetch () {
            try {
                return await this.$get('/history/' + this.$route.params.bundle + '/' + this.$route.params.objectId, {
                    'page': this.page,
                    'limit': this.limit,
                });
            } catch (error) {
                this.showError = true;
                console.log(error);
            }
        },
        /**
         * Change page
         *
         * @param page
         */
        async changePage (page) {
            this.page = page > this.data.pageJumper.numberOfPages ? this.data.pageJumper.numberOfPages : page;
            this.data = await this.fetch();
        },
        /**
         * Open modal
         */
        openModal (history) {
            this.modalData = history;
        },
        /**
         * Close modal
         */
        closeModal () {
            this.modalData = null;
        }
    },
    filters: {
        pretty : (val, indent = 2) => {
            console.log(val, indent);
            if (typeof val === "string") {
                val = JSON.parse(val)
            }
            return JSON.stringify(val, null, indent)
        }
    },
    /**
     * Created
     */
    async created() {
        this.data = await this.fetch();
    }
}, 'cms/pages/cms-history.html');
